/*
  Constantes partagées par les modules du site.
*/

export const html = document.documentElement;

/** Les personnes qui limitent les animations n'ont ni Lenis, ni parallax, ni rideau. */
export const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

/** Courbe des mouvements du rideau. */
export const EASE = 'cubic-bezier(0.76, 0, 0.24, 1)';
